/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleFormConfiguration
 */
export interface OsisRuleFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly dateTimeZones?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof OsisRuleFormConfiguration
     */
    readonly relevances?: Array<number> | null;
}

export function OsisRuleFormConfigurationFromJSON(json: any): OsisRuleFormConfiguration {
    return OsisRuleFormConfigurationFromJSONTyped(json, false);
}

export function OsisRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'dateTimeZones': !exists(json, 'dateTimeZones') ? undefined : (json['dateTimeZones'] === null ? null : (json['dateTimeZones'] as Array<any>).map(CodeAndLabelFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
    };
}

export function OsisRuleFormConfigurationToJSON(value?: OsisRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


